import {ApiUrls} from 'shared/config/model/urls';

import React from 'react';
import {SubmitHandler} from 'react-hook-form';
import {t} from '@lingui/core/macro';

import ModalBlockButton from 'shared/ui/Button/ModalBlockButton/ModalBlockButton';
import {ExportResult, useExportRequest} from 'entities/monitor';
import {IPortMonitorListItem} from 'features/port/model/PortMonitor/IPortMonitor';

import {buildPortIncidentsExportRequest} from './portIncidentsExportRequest';
import PortIncidentsFiltersForm, {IPortIncidentFiltersForm} from '../PortIncidentsFilters/PortIncidentsFiltersForm';

interface IPortIncidentsExportFormHandlerProps {
    monitors: IPortMonitorListItem[],
    handleClose: () => void,
}

const PortIncidentsExportFormHandler: React.FC<IPortIncidentsExportFormHandlerProps> = ({monitors, handleClose}) => {
    const {result, isLoading, progress, submit, reset} = useExportRequest(ApiUrls.PORT_INCIDENTS_EXPORT);

    const onSubmit: SubmitHandler<IPortIncidentFiltersForm> = async(formData) => {
        await submit(buildPortIncidentsExportRequest(formData));
    };

    const handleCloseResult = () => {
        handleClose();
        reset();
    };

    if (result) {
        return (
            <ExportResult
                result={result}
                countLabel={t`Экспортировано инцидентов портов`}
                handleClose={handleCloseResult}
            />
        );
    }

    return (
        <PortIncidentsFiltersForm
            monitors={monitors}
            onSubmit={onSubmit}
            button={
                <ModalBlockButton
                    primaryButtonText={t`Экспортировать`}
                    primaryButtonType="submit"
                    primaryButtonLoading={isLoading}
                    secondaryButtonOnClick={handleClose}
                    progress={progress}
                />
            }
        />
    );
};

export default PortIncidentsExportFormHandler;
